import en from './en';

// English is kept as the fallback baseline; translated keys below override it.
const zh = {
  ...en,
  " · 만료됨": " · 已过期",
  "(password 있음)": "（已设置密码）",
  "(링크 없음)": "（无链接）",
  "(본문 없음)": "（无内容）",
  "(없음)": "（无）",
  "(이름없음)": "（未命名）",
  "(자동)": "（自动）",
  "(제목 없음)": "（无标题）",
  "+ 공지 작성": "+ 创建公告",
  "+ 광고 등록": "+ 添加广告",
  "+ 새 공지 작성": "+ 新公告",
  "+ 새 광고 등록": "+ 新广告",
  "+ 아이콘(업로드)": "+ 图标（上传）",
  "+ 이미지": "+ 图片",
  "+ 인포 버튼 추가": "+ 添加信息按钮",
  "+ 인포카드 추가": "+ 添加信息卡",
  "+ 텍스트": "+ 文本",
  "0 이상 숫자를 입력하세요.": "请输入大于或等于 0 的数字。",
  "0보다 큰 금액을 입력하세요.": "请输入大于 0 的金额。",
  "0보다 큰 숫자만 가능": "只能输入大于 0 的数字。",
  "24시간 반복": "每 24 小时重复",
  "2차 비밀번호(선택)": "二级密码（可选）",
  "Country 필터": "国家筛选",
  "Device 필터": "设备筛选",
  "DisplaySet 날짜 필터(1일 단위)": "DisplaySet 日期筛选（1天单位）",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "请输入有效的到期日期/时间。",
  "Due Date를 입력해야 합니다.": "必须输入到期日。",
  "Rake % (수수료율)": "Rake %（手续费率）",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB 必须是大于 0 的数字，最多 2 位小数。例如：0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share 必须是 0 到 1 之间的数字（例如 0.2）。",
  "endAt은 startAt보다 늦어야 해.": "endAt 必须晚于 startAt。",
  "message는 빈값이 될 수 없습니다.": "消息不能为空。",
  "message는 필수입니다.": "消息为必填项。",
  "⚠️ 권한이 없습니다": "⚠️ 您没有权限",
  "개": "个",
  "개 · 남은 수량": "个 · 剩余数量",
  "갱신 주기(일)": "更新周期（天）",
  "건": "条记录",
  "검색": "搜索",
  "검색 (id / user_code / nickname / 메모)": "搜索（id / user_code / 昵称 / 备注）",
  "검색: 이름/링크/국가": "搜索：名称/链接/国家",
  "검색: 제목/본문/작성자": "搜索：标题/内容/作者",
  "검색어를 입력하세요": "请输入搜索词",
  "게시": "已发布",
  "게시 상태": "发布状态",
  "게시 중": "发布中",
  "결제 영역": "支付区域",
  "결제 옵션": "支付选项",
  "결제 옵션 추가": "添加支付选项",
  "결제 완료": "支付完成",
  "결제 항목": "支付项目",
  "결제관리": "支付管理",
  "경로": "路径",
  "공지 관리": "公告管理",
  "공지 본문": "公告正文",
  "공지 수정": "编辑公告",
  "공지 작성/관리": "公告创建/管理",
  "공지 제목": "公告标题",
  "공지가 없어. 위에서 새로 작성해줘.": "没有公告。请在上方新建。",
  "관리": "管理",
  "관리 상태": "管理状态",
  "관리자 자산 표시 영역": "管理员资产汇总区域",
  "광고 관리": "广告管理",
  "광고 목록을 불러오지 못했어.": "广告列表加载失败。",
  "광고 삭제에 실패했어.": "删除广告失败。",
  "광고 수정": "编辑广告",
  "광고 이미지": "广告图片",
  "광고 이미지 등록/관리": "广告图片注册/管理",
  "광고 이미지를 업로드해줘.": "请上传广告图片。",
  "광고 저장에 실패했어.": "保存广告失败。",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "输入国家。例如：KR / US / JP / ALL",
  "굵기": "粗细",
  "그룹 노출(DisplaySet)": "分组展示（DisplaySet）",
  "그룹 미션": "分组任务",
  "그룹 미션 설정": "分组任务设置",
  "그룹 미션 시작": "启动分组任务",
  "그룹 생성": "创建分组",
  "그룹 시간 설정이 올바르지 않습니다.": "分组时间设置无效。",
  "그룹 이름": "分组名称",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "分组名称、Small Blind、Big Blind 为必填。SB/BB 可输入如 0.25、0.50。",
  "그룹명": "分组名称",
  "글로벌": "全局",
  "금액": "金额",
  "금액은 최소 50$ 이상 부터 가능합니다.": "金额必须至少为 $50。",
  "기간": "期间",
  "나의 지갑 주소": "我的钱包地址",
  "남미": "南美",
  "내부용 이름(label)": "内部名称（label）",
  "내부용 이름(label)을 입력해줘.": "请输入内部名称（label）。",
  "내용(message)": "内容（message）",
  "노출": "显示",
  "노출(즉시/기간무관)": "显示（立即 / 不限期间）",
  "노출중": "显示",
  "닉네임": "昵称",
  "다음": "下一页",
  "닫기": "关闭",
  "데이터 없음": "无数据",
  "데이터가 없습니다.": "暂无数据。",
  "동남아": "东南亚",
  "동아시아": "东亚",
  "등록": "注册",
  "등록된 광고가 없어.": "没有已注册广告。",
  "등록된 라운지 글이 없습니다.": "没有已注册的休闲区帖子。",
  "등록된 이미지 없음": "没有已注册图片",
  "라운지 관리": "休闲区管理",
  "라운지 글": "休闲区帖子",
  "라운지 글 목록": "休闲区帖子列表",
  "라운지 목록을 불러오지 못했습니다.": "休闲区列表加载失败。",
  "라운지 아이템": "休闲区项目",
  "라운지 업로드": "休闲区上传",
  "라운지 포인트 %": "休闲区积分 %",
  "라운지 포인트 % (0~100)": "休闲区积分 %（0–100）",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "休闲区积分 % 必须是 0 到 100 之间的数字，最多 2 位小数。",
  "라운지 포인트 지급률": "休闲区积分奖励率",
  "라운지 포인트 지급률 저장 실패": "保存休闲区积分奖励率失败",
  "라운지포인트": "休闲区积分",
  "레이크백": "返水",
  "로그아웃": "退出登录",
  "로그인": "登录",
  "로그인 실패: ": "登录失败：",
  "로딩 중...": "加载中...",
  "로딩중...": "加载中...",
  "링크 열기": "打开链接",
  "링크:": "链接：",
  "만료": "已过期",
  "메모": "备注",
  "메인 영역": "主区域",
  "명": "名用户",
  "무한(30일 갱신)": "无限（30天更新）",
  "무한(infinite) 항목(상시 노출)": "无限项目（始终显示）",
  "무한(약 {days}일 단위 갱신)": "无限（约每 {days} 天更新）",
  "미결제": "未支付",
  "미리보기": "预览",
  "미션 RUN 생성 실패": "创建任务 RUN 失败",
  "미션 cfg 저장 실패": "保存任务 cfg 失败",
  "미션 상금 분배(프론트 계산)": "任务奖金分配（前端计算）",
  "미션 상태 조회 실패": "加载任务状态失败",
  "받는 지갑": "收款钱包",
  "받는쪽 (to)": "接收方（to）",
  "배경 색상": "背景颜色",
  "배경 이미지 URL": "背景图片 URL",
  "배경 타입": "背景类型",
  "보내는 지갑": "付款钱包",
  "보낸쪽 (from)": "发送方（from）",
  "복사": "复制",
  "복사 실패(브라우저 권한 확인)": "复制失败（请检查浏览器权限）",
  "본문": "正文",
  "본문 내용을 입력하세요": "请输入正文内容",
  "본문을 입력해줘.": "请输入正文。",
  "본인 {id}": "本人 {id}",
  "북미": "北美",
  "분배 비율": "分配比例",
  "분배 비율(상대 %)": "分配比例（相对 %）",
  "불러오기 실패": "加载失败",
  "불러오는 중…": "加载中…",
  "비밀번호": "密码",
  "비활성": "已禁用",
  "삭제": "删除",
  "삭제 실패": "删除失败",
  "삭제됨": "已删除",
  "상세": "详情",
  "상시": "始终",
  "상위 에이전트:": "上级代理：",
  "상태": "状态",
  "새 공지 작성": "创建新公告",
  "새 광고 등록": "创建新广告",
  "새 전광판 등록": "创建新跑马灯",
  "새로고침": "刷新",
  "색상": "颜色",
  "생성": "创建",
  "생성 중...": "创建中...",
  "생성 중…": "创建中…",
  "서버 오류": "服务器错误",
  "서버로 전송될 preset 문자열(콤마 구분)": "发送到服务器的 preset 字符串（逗号分隔）",
  "세컨드 비밀번호(옵션)": "二级密码（可选）",
  "소속 유저": "所属用户",
  "수량": "数量",
  "수수료": "手续费",
  "수수료 수정": "编辑手续费",
  "수수료 수정 실패": "编辑手续费失败",
  "수정": "编辑",
  "수정 모드": "编辑模式",
  "시간 설정": "时间设置",
  "시간 설정이 올바르지 않습니다.": "时间设置无效。",
  "시작": "开始",
  "시작(로컬)": "开始（本地）",
  "시작일": "开始日期",
  "아래로": "下移",
  "아이콘 파일은 1MB 이하로 올려주세요.": "图标文件必须小于等于 1MB。",
  "아프리카": "非洲",
  "언어": "语言",
  "업로드": "上传",
  "업로드 URL을 받지 못했습니다.": "未收到上传 URL。",
  "업로드 URL을 받지 못했어.": "未收到上传 URL。",
  "업로드/게시": "上传/发布",
  "업로드중...": "上传中...",
  "에이전트": "代理",
  "에이전트 상금풀(": "代理奖池（",
  "에이전트로 생성": "创建为代理",
  "예약": "已预约",
  "예약 시간이 올바르지 않습니다.": "预约时间无效。",
  "예약 없음": "无预约",
  "예약/상태": "预约/状态",
  "오래된순": "最旧优先",
  "요소(최대 4개)": "元素（最多 4 个）",
  "요청 실패 ({status})": "请求失败（{status}）",
  "용량": "大小",
  "위로": "上移",
  "유럽": "欧洲",
  "유저 관리": "用户管理",
  "유저코드": "用户代码",
  "유효 인포메이션 버튼:": "有效信息按钮：",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "您没有权限访问此页面。",
  "이동 URL": "目标 URL",
  "이미지": "图片",
  "이미지 URL": "图片 URL",
  "이미지 블록": "图片块",
  "이미지 업로드 실패: {message}": "图片上传失败：{message}",
  "이미지 업로드 중...": "图片上传中...",
  "이미지 업로드에 실패했습니다.": "图片上传失败。",
  "이미지 업로드중...": "图片上传中...",
  "이미지 없음": "无图片",
  "이미지 열기": "打开图片",
  "이미지 파일만 등록할 수 있어.": "只能注册图片文件。",
  "이미지 파일만 업로드할 수 있어.": "只能上传图片文件。",
  "이미지(URL)": "图片（URL）",
  "이미지는 5MB 이하만 업로드할 수 있어.": "图片必须小于等于 5MB。",
  "이전": "上一页",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "信息按钮时间设置无效。",
  "인포 버튼 프리셋 수정": "编辑信息按钮预设",
  "인포메이션 버튼(선택)": "信息按钮（可选）",
  "인포버튼 없음": "无信息按钮",
  "인포버튼 프리셋 수정": "编辑信息按钮预设",
  "인포카드 추가": "添加信息卡",
  "인포카드 타이머": "信息卡计时器",
  "일": "天",
  "일 /": "天 /",
  "일/": "天/",
  "일반 자산": "主资产",
  "임시": "草稿",
  "임시저장": "草稿",
  "입력값을 확인해 주세요.": "请检查输入值。",
  "자산": "资产",
  "자산 타입": "资产类型",
  "자산기록": "资产流水",
  "작성": "创建",
  "작성자": "作者",
  "재시작": "重启",
  "저장": "保存",
  "저장 중...": "保存中...",
  "저장중...": "保存中...",
  "적용": "应用",
  "전광판 관리": "跑马灯管理",
  "전광판 등록 실패": "创建跑马灯失败",
  "전광판 목록 조회 실패": "加载跑马灯列表失败",
  "전광판 삭제 실패": "删除跑马灯失败",
  "전광판 수정 실패": "编辑跑马灯失败",
  "전체": "全部",
  "전체 상태": "整体状态",
  "접기": "折叠",
  "정렬": "排序",
  "정렬 변경에 실패했어.": "更改排序失败。",
  "정렬 저장": "保存排序",
  "정렬 저장 실패": "保存排序失败",
  "정보 수정 실패": "编辑信息失败",
  "정보수정": "编辑信息",
  "정상": "正常",
  "제거": "移除",
  "제목": "标题",
  "제목을 입력하세요": "请输入标题",
  "제목을 입력해줘.": "请输入标题。",
  "조회": "搜索",
  "종료(로컬)": "结束（本地）",
  "종료일": "结束日期",
  "중동": "中东",
  "중앙아시아": "中亚",
  "중지": "停止",
  "지갑 주소": "钱包地址",
  "지금": "现在",
  "지급": "入账",
  "지급 실패": "入账失败",
  "차감": "扣款",
  "차감 실패": "扣款失败",
  "차단": "封禁",
  "차단 해제": "解除封禁",
  "차단됨": "已封禁",
  "처리 중...": "处理中...",
  "초기화": "重置",
  "초안": "草稿",
  "총 상금풀(1.5%):": "总奖池（1.5%）：",
  "총베팅액:": "总投注额：",
  "최근순": "最新优先",
  "출금하기": "提现",
  "충전 하기": "充值",
  "취소": "取消",
  "카테고리": "分类",
  "크기(px)": "大小（px）",
  "클릭 시 출금이 시작 됩니다.": "点击后开始提现。",
  "클릭 이동 URL(link_url)": "点击跳转 URL（link_url）",
  "클릭 이동 링크(URL)": "点击跳转链接（URL）",
  "클릭하면 등록 모달": "点击打开注册弹窗",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "点击将显示基准时间设为该日期。",
  "클릭하여 이미지 업로드": "点击上传图片",
  "타이머 없음": "无计时器",
  "타이머 타입": "计时器类型",
  "타이머(존재유무만)": "计时器（仅存在状态）",
  "타이머는": "计时器为",
  "타입": "类型",
  "테이블 관리": "牌桌管理",
  "테이블 그룹 목록 조회 실패": "加载牌桌分组列表失败",
  "테이블 그룹 생성 실패": "创建牌桌分组失败",
  "테이블 그룹 생성 완료": "牌桌分组创建成功",
  "테이블 그룹 코드 생성 실패": "生成牌桌分组代码失败",
  "테이블 그룹이 없습니다.": "没有牌桌分组。",
  "테이블 미션": "牌桌任务",
  "테이블 미션 RUN 생성 실패": "创建牌桌任务 RUN 失败",
  "테이블 미션 RUN 중지 실패": "停止牌桌任务 RUN 失败",
  "테이블 미션 cfg 저장 실패": "保存牌桌任务 cfg 失败",
  "테이블 미션 상금 분배(프론트 계산)": "牌桌任务奖金分配（前端计算）",
  "테이블 미션 상태 조회 실패": "加载牌桌任务状态失败",
  "텍스트": "文本",
  "텍스트 블록": "文本块",
  "텍스트 스타일": "文本样式",
  "파일명": "文件名",
  "판매": "已售",
  "페이지": "页面",
  "페이지 크기": "每页数量",
  "펼치기": "展开",
  "폰트스타일": "字体样式",
  "표시 기준 시간": "显示基准时间",
  "표시 순서(order)": "显示顺序（order）",
  "표시 여부만": "仅显示状态",
  "표시명": "显示名称",
  "표시할 기록이 없습니다.": "没有可显示的记录。",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "前端测试：转账完成处理（连接后端前）",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "前端测试：开始提现处理（连接后端前）",
  "프리셋 수정": "编辑预设",
  "프리셋(배경/요소/URL)": "预设（背景/元素/URL）",
  "플레이어 상금풀(": "玩家奖池（",
  "플레이어 수수료 설정": "玩家手续费设置",
  "하위": "下级",
  "하위 {id}": "下级 {id}",
  "하위 계정 생성": "创建下级账号",
  "하위 생성": "创建下级",
  "하위 생성 (부모:": "创建下级（上级：",
  "하이라이트 메세지": "高亮信息",
  "하이라이트 포인트": "亮点",
  "현재 라운지 포인트 %": "当前休闲区积分 %",
  "확인용 테스트 거래 시작": "开始测试交易",
  "활성 RUN이 없습니다.": "没有活动 RUN。",
  "회원 정보 수정": "编辑会员信息",
  "🔐 어드민 로그인": "🔐 管理员登录",
};

export default zh;
